import React from 'react'

const Hero = () => {
  return (
    <div className='bg-aboutus-hero h-[100vh] md:h-fit lg:h-[100vh] w-full bg-cover bg-center flex flex-col justify-center'>
        <div className='text-[#fff] w-[90%] md:w-[75%] lg:w-[55%] py-[25vh] lg:py-0 px-6 md:px-12 lg:pl-36 flex flex-col gap-4' >
          <h1 className='text-5xl font-mosk600' >About us...</h1>
          <p className=' font-light text-lg lg:text-xl' >Our Journey Our story began as passionpreneurs with a profound appreciation for the art of crafting exceptional events. From the foundational basics to the cutting-edge innovations, we understand the integral elements that contribute to a successful event. In today's dynamic world, where events transcend mere gatherings, Blue Door Event Solutions emerges as a boutique agency at the forefront of the industry.</p>
        </div>
    </div>
  )
}

export default Hero
